
export const enum AvailabilityIntervalGroup {
  TIME_OF_DAY = 'TIME_OF_DAY',
  DAY_OF_WEEK = 'DAY_OF_WEEK',
}

export const enum AvailabilityTimeOfDayInterval {
  EARLY_MORNING = 'EARLY_MORNING',
  MORNING = 'MORNING',
  AFTERNOON = 'AFTERNOON',
  EVENING = 'EVENING',
}


export const enum AvailabilityDayOfWeekInterval {
  MONDAY = '0',
  TUESDAY = '1',
  WEDNESDAY = '2',
  THURSDAY = '3',
  FRIDAY = '4',
  SATURDAY = '5',
  SUNDAY = '6',
}
